import * as catBrandActionImport from '@appActions/catalogs/marca.actions';
import * as addressActionsImport from '@appActions/catalogs/direccion.actions';
import * as scheduleActionsImport from '@appActions/catalogs/horario.actions';
import * as catalogsActionsImport from '@appActions/catalogs/catalogos.actions';
import * as clientActionsImport from '@appActions/catalogs/cliente.actions';

export const catBrandActions = catBrandActionImport;
export const catAddressActions = addressActionsImport;
export const catScheduleActions = scheduleActionsImport;
export const catalogsActions = catalogsActionsImport;
export const clientActions = clientActionsImport;
